/**
 * Token mapper
 * @returns the mapper for token
 */
export const tokenMapper = () => {
  return {
    'token-read': ['auth/tokens:read'],
    'token-write': ['auth/tokens:read', 'auth/tokens:write'],
  };
};

/**
 * User mapper
 * @returns the mapper for user
 */
export const userMapper = () => {
  return {
    'user-read': ['auth/users:read'],
    'user-write': ['auth/users:read', 'auth/users:write'],
  };
};

/**
 * Client mapper
 * @returns the mapper for client (incl. private-credential reveal)
 */
export const clientMapper = () => {
  return {
    'client-read': ['auth/clients:read'],
    'client-write': ['auth/clients:read', 'auth/clients:write'],
    'client-private': ['auth/clients:read:private'],
    'client-private-write': ['auth/clients:read:private', 'auth/clients:write'],
  };
};

/**
 * Historical pull mapper
 * @returns the mapper for historical data pull
 */
export const historicalPullMapper = () => {
  return {
    'historical-pull-read': ['jobs:read', 'auth/clients:read'],
    'historical-pull-write': ['jobs:read', 'auth/clients:read', 'jobs:write:sync-activities'],
  };
};

/**
 * Market mapper
 * @returns the mapper for market area
 */
export const marketMapper = () => {
  return {
    'market-area-read': ['auth/market-areas:read'],
    'market-area-write': ['auth/market-areas:read', 'auth/market-areas:write'],
  };
};
